 <!--Loading Spinner-->
 <div *ngIf="isLoading">
  <app-spinner></app-spinner>
</div>

 <!-- Main content -->
 <div class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-sm-6 col-md-3">
        <a routerLink="/suppliers/stock-list">
        <div class="info-box">
          <span class="info-box-icon bg-info elevation-1"><i class="fa fa-hourglass-end"></i></span>

          <div class="info-box-content">
            <span class="info-box-text">Vehicles In Japan Stock</span>
            <span class="info-box-number">
              {{units_in_supplier_stock_count}}
            </span>
          </div>
          <!-- /.info-box-content -->
        </div>
        </a>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
      <div class="col-12 col-sm-6 col-md-3">
        <a routerLink="/stock-overview/stock-en-route-ug">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-primary elevation-1"><i class="fas fa-ship"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Vehicles En route</span>
              <span class="info-box-number">{{units_enroute_count}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </a>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->

      <!-- fix for small devices only -->
      <div class="clearfix hidden-md-up"></div>

      <div class="col-12 col-sm-6 col-md-3">
        <a routerLink="/stock-overview/stock-at-cfs-ug">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-success elevation-1"><i class="fas fa-anchor"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">Vehicles At CFS</span>
              <span class="info-box-number">{{units_at_cfs_count}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </a>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
      <div class="col-12 col-sm-6 col-md-3">
        <a routerLink="/vehicle-transfer-in-transit">
          <div class="info-box mb-3">
            <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-truck"></i></span>

            <div class="info-box-content">
              <span class="info-box-text">In Transit to UG</span>
              <span class="info-box-number">{{units_in_transit_to_ug_count}}</span>
            </div>
            <!-- /.info-box-content -->
          </div>
        </a>
        <!-- /.info-box -->
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->
    <div class="row">
      <div class="col-lg-6">
        <div class="card card-warning card-outline">
          <div class="card-header">
            <h5 class="m-0">Total Stock</h5>
          </div>
          <div class="card-body"  style="width: 600px;height:400px;">
            <canvas  id="TotalStockChart" >{{ total_stock_chart }}</canvas>
          </div>
        </div>

        <div class="card card-warning card-outline">
          <div class="card-header">
            <h5 class="m-0">Available Makes</h5>
          </div>

          <div class="card-body">
            <div class="row mb-3">
              <div class="col-md-4">
                <select class="form-control"
                        (change)="onSelectChange($event.target)"
                        [(ngModel)]="selectedBranch">
                  <option value="">All Branches</option>

                  <option [value]="branch.branch_id"
                          *ngFor="let branch of branches">
                    {{ branch.location_name }} - {{ branch.branch_name }}
                  </option>
                </select>
              </div>

              <div class="col-md-5"></div>

              <div class="col-md-3">
                <input type="text"
                       class="form-control"
                       placeholder="Type here to search..."
                       (input)="onSearchTextChange($event)">
              </div>
            </div>

            <div class="d-flex flex-wrap">
              <div
                class="badge badge-light border p-3 mr-2 mb-2"
                style="font-size: 14px; cursor: pointer;"
                *ngFor="let row of stock_available_by_make | searchMake: searchText | paginate: { itemsPerPage: 20, currentPage: page, totalItems: count, id: 'units_by_make' }"
                (click)="openAvailableModelsModal(row.make_id, row.make_name)"
              >
                <span class="font-weight-bold">
                  {{ row.make_name }}
                </span>

                <span class="badge badge-warning ml-2">
                  {{ row.units_available }}
                </span>

                <i class="fas fa-eye ml-2 text-danger"></i>
              </div>
            </div>
          </div>

          <div class="card-footer clearfix">
            <div class="float-right">
              <pagination-controls
                (pageChange)="pageChangeEvent($event)" id="units_by_make">
              </pagination-controls>
            </div>
          </div>
        </div>
      </div>
      <!-- /.col-md-6 -->
      <div class="col-lg-6">
        <div class="card card-warning card-outline">
          <div class="card-header">
            <h5 class="m-0">Units Pending Payments</h5>
          </div>
          <div class="card-body">

            <div class="progress-group">
              Pending Entry
              <span class="float-right"><b>{{ pendingPayments.pending_entry.pending_count }}</b>/{{ pendingPayments.pending_entry.total }}</span>
              <div class="progress progress-sm">
                <div class="progress-bar" [style.width.%]="pendingPayments.pending_entry.percentage_completed"
                [ngClass]="getProgressBarClass(pendingPayments.pending_entry.percentage_completed)"
                [title]="pendingPayments.pending_entry.completed_count
                + ' paid ('
                + pendingPayments.pending_entry.percentage_completed.toFixed(0)
                + '%)'"></div>
              </div>
            </div>

            <div class="progress-group">
              Pending D.O Payments
              <span class="float-right"><b>{{ pendingPayments.pending_do_payments.pending_count }}</b>/{{ pendingPayments.pending_do_payments.total }}</span>
              <div class="progress progress-sm">
                <div class="progress-bar" [style.width.%]="pendingPayments.pending_do_payments.percentage_completed"
                [ngClass]="getProgressBarClass(pendingPayments.pending_do_payments.percentage_completed)"
                [title]="pendingPayments.pending_do_payments.completed_count
                + ' paid ('
                + pendingPayments.pending_do_payments.percentage_completed.toFixed(0)
                + '%)'"></div>
              </div>
            </div>

            <div class="progress-group">
              Pending UNBS Charges
              <span class="float-right"><b>{{ pendingPayments.pending_unbs_charges.pending_count }}</b>/{{ pendingPayments.pending_unbs_charges.total }}</span>
              <div class="progress progress-sm">
                <div class="progress-bar" [style.width.%]="pendingPayments.pending_unbs_charges.percentage_completed"
                [ngClass]="getProgressBarClass(pendingPayments.pending_unbs_charges.percentage_completed)"
                [title]="pendingPayments.pending_unbs_charges.completed_count
                + ' paid ('
                + pendingPayments.pending_unbs_charges.percentage_completed.toFixed(0)
                + '%)'"></div>
              </div>
            </div>

            <div class="progress-group">
              <span class="progress-text">Pending Port Charges</span>
              <span class="float-right"><b>{{ pendingPayments.pending_port_charges.pending_count }}</b>/{{ pendingPayments.pending_port_charges.total }}</span>
              <div class="progress progress-sm">
                <div class="progress-bar" [style.width.%]="pendingPayments.pending_port_charges.percentage_completed"
                [ngClass]="getProgressBarClass(pendingPayments.pending_port_charges.percentage_completed)"
                [title]="pendingPayments.pending_port_charges.completed_count
                + ' paid ('
                + pendingPayments.pending_port_charges.percentage_completed.toFixed(0)
                + '%)'"></div>
              </div>
            </div>

            <div class="progress-group">
              <span class="progress-text">Pending Toll Charges</span>
              <span class="float-right"><b>{{ pendingPayments.pending_toll_charges.pending_count }}</b>/{{ pendingPayments.pending_toll_charges.total }}</span>
              <div class="progress progress-sm">
                <div class="progress-bar" [style.width.%]="pendingPayments.pending_toll_charges.percentage_completed"
                [ngClass]="getProgressBarClass(pendingPayments.pending_toll_charges.percentage_completed)"
                [title]="pendingPayments.pending_toll_charges.completed_count
                + ' paid ('
                + pendingPayments.pending_toll_charges.percentage_completed.toFixed(0)
                + '%)'"></div>
              </div>
            </div>

            <div class="progress-group">
              Pending Foreign Permit
              <span class="float-right"><b>{{ pendingPayments.pending_foreign_permit.pending_count }}</b>/{{ pendingPayments.pending_foreign_permit.total }}</span>
              <div class="progress progress-sm">
                <div class="progress-bar" [style.width.%]="pendingPayments.pending_foreign_permit.percentage_completed"
                [ngClass]="getProgressBarClass(pendingPayments.pending_foreign_permit.percentage_completed)"
                [title]="pendingPayments.pending_foreign_permit.completed_count
                + ' paid ('
                + pendingPayments.pending_foreign_permit.percentage_completed.toFixed(0)
                + '%)'"></div>
              </div>
            </div>

            <div class="progress-group">
              <span class="progress-text">Pending Number Plate Payment</span>
              <span class="float-right"><b>{{ pendingPayments.pending_number_plate.pending_count }}</b>/{{ pendingPayments.pending_number_plate.total }}</span>
              <div class="progress progress-sm">
                <div class="progress-bar" [style.width.%]="pendingPayments.pending_number_plate.percentage_completed"
                [ngClass]="getProgressBarClass(pendingPayments.pending_number_plate.percentage_completed)"
                [title]="pendingPayments.pending_number_plate.completed_count
                + ' paid ('
                + pendingPayments.pending_number_plate.percentage_completed.toFixed(0)
                + '%)'"></div>
              </div>
            </div>

            <div class="progress-group">
              Pending KE Insurance
              <span class="float-right"><b>{{ pendingPayments.pending_ke_insurance.pending_count }}</b>/{{ pendingPayments.pending_ke_insurance.total }}</span>
              <div class="progress progress-sm">
                <div class="progress-bar" [style.width.%]="pendingPayments.pending_ke_insurance.percentage_completed"
                [ngClass]="getProgressBarClass(pendingPayments.pending_ke_insurance.percentage_completed)"
                [title]="pendingPayments.pending_ke_insurance.completed_count
                + ' paid ('
                + pendingPayments.pending_ke_insurance.percentage_completed.toFixed(0)
                + '%)'"></div>
              </div>
            </div>

          </div>
        </div>

        <div class="card card-warning card-outline">
          <div class="card-header">
            <h5 class="m-0">Due Duty Payments</h5>
          </div>
          <div class="card-body">

            <div class="card card-widget widget-user-2">

              <div class="card-footer p-0">

                  <ul class="nav flex-column">

                      <li class="nav-item" *ngFor="let item of dueDutyPayments">

                          <a href="javascript:void(0)" class="nav-link">

                              {{ item.title }}

                              <span class="badge bg-{{ item.badge_class }}">
                                  {{ item.units | number }} Units
                              </span>

                              <span class="float-right badge bg-{{ item.badge_class }}">
                                  UGX {{ item.amount | number }}
                              </span>

                          </a>

                      </li>

                  </ul>

              </div>

          </div>

          </div>
        </div>
      </div>
      <!-- /.col-md-6 -->
    </div>
    <!-- /.row -->
  </div><!-- /.container-fluid -->
</div>
<!-- /.content -->

<!-- Modal -->
<div class="modal fade" #AvailableModels tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-sm" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">{{make_name}} MODELS</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="row">
        <div class="col" style="margin: 2px 5px;">
          <input type="text" class="form-control" placeholder="Type here to search..." (input)="modelOnSearchTextChange($event)">
        </div>
      </div>
      <table id="example1" class="table table-bordered table-hover table-striped">
        <tr *ngFor="let row of stock_available_by_model | searchModel: modelSearchText | paginate: { itemsPerPage: 10, currentPage: model_page, totalItems: model_count, id: 'avail_models' }">
          <td><a href="#" (click)="openAvailableUnitsModal(row.model_id,row.model_name)">{{row.model_name}} ({{row.units_available}})</a></td>
        </tr>
      </table>
      <pagination-controls (pageChange)="modelPageChangeEvent($event)" id="avail_models"></pagination-controls>
    </div>
  </div>
</div>

<!-- Available Units Modal -->
<div class="modal fade" #AvailableUnits tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content" style="overflow-x: auto; overflow-y: auto; white-space: nowrap;">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Units Under {{make_name}} {{model_name}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="row">
        <div class="col-md-8"></div>
        <div class="col-md-4">
          <div class="row">
              <div class="col" style="margin: 2px 5px;">
                  <input type="text" class="form-control" placeholder="Search by Chassis Number" (input)="unitsOnSearchTextChange($event)">
              </div>
          </div>
        </div>
      </div>
      <table id="example1" class="table table-bordered table-hover table-striped">
        <thead>
          <tr>
            <th>MAKE</th>
            <th>MODEL</th>
            <th>CHASSIS NO.</th>
            <th>CC</th>
            <th>FUEL</th>
            <th>COLOUR</th>
            <th>TOTAL COST</th>
            <th>LOCATION</th>
          </tr>
        </thead>
        <tr *ngFor="let unit of units_by_model | searchVehicle: unitsSearchText | paginate: { itemsPerPage: 10, currentPage: units_page, totalItems: units_count, id: 'units_by_model' }">
          <td>{{unit.make}}</td>
          <td>{{unit.model}}</td>
          <td>{{unit.chassis_no}}</td>
          <td>{{unit.engine_cc}}</td>
          <td>{{unit.fuel}}</td>
          <td>{{unit.colour}}</td>
          <td>{{unit.total| currency:'Kshs '}}</td>
          <td>{{unit.location_name}}-{{unit.branch_name}}</td>
        </tr>
      </table>
      <pagination-controls (pageChange)="unitsPageChangeEvent($event)"  id="units_by_model"></pagination-controls>
    </div>
  </div>
</div>
